const piletPrefix = 'billing_';
const eventPrefix = 'event_';

// usage: data-analytics-id={analyticsIds.createButton}
export const analyticsIds = {
	backToAccountAdministrationButton: `${piletPrefix}BackToAccountAdministrationButton`,
	cancelMyAccountButton: `${piletPrefix}CancelMyAccountButton`,
	cancelTrialButton: `${piletPrefix}CancelTrialButton`,
	convertNowButton: `${piletPrefix}ConvertNowButton`,
	convertNowModalCancelButton: `${piletPrefix}ConvertNowModalCancelButton`,
	convertNowModalOkButton: `${piletPrefix}ConvertNowModalOkButton`,
	creditCardOverduePayNowButton: `${piletPrefix}CreditCardOverduePayNowButton`,
	currentPlanAddStorageButton: `${piletPrefix}CurrentPlanAddStorageButton`,
	currentPlanAddUsersButton: `${piletPrefix}CurrentPlanAddUsersButton`,
	editCCButton: `${piletPrefix}EditCCButton`,
	invoiceOverduePayNowButton: `${piletPrefix}InvoiceOverduePayNowButton`,
	managePlanModalAddButton: `${piletPrefix}ManagePlanModalAddButton`,
	managePlanModalCancelButton: `${piletPrefix}ManagePlanModalCancelButton`,
	managePlanModalUpgradeButton: `${piletPrefix}ManagePlanModalUpgradeButton`,
	managePlanUpgradeCardButton: `${piletPrefix}ManagePlanUpgradeCardButton`,
	switchToCCButton: `${piletPrefix}SwitchToCCButton`,
};

// usage: sendPendoTrackEvent(events.navigateToMyTemplatesTab, { optional: 'metadata' });
export const events = {
	cancelAccountFailure: `${piletPrefix}${eventPrefix}CancelAccountFailure`,
	cancelAccountSuccess: `${piletPrefix}${eventPrefix}CancelAccountSuccess`,
	cancelTrialSuccess: `${piletPrefix}${eventPrefix}CancelTrialSuccess`,
	cancelTrialFailure: `${piletPrefix}${eventPrefix}CancelTrialFailure`,
	closeEditCCModal: `${piletPrefix}${eventPrefix}CloseEditCCModal`,
	closeSwitchToCCModal: `${piletPrefix}${eventPrefix}CloseSwitchToCCModal`,
	ccUpdateSuccess: `${piletPrefix}${eventPrefix}CCUpdateSuccess`,
	ccUpdateFailure: `${piletPrefix}${eventPrefix}CCUpdateFailure`,
	managePlanModalDismiss: `${piletPrefix}${eventPrefix}ManagePlanModalDismiss`,
};

interface Window {
	pendo?: any;
}

export function sendPendoTrackEvent(event: string, metadata: any = {}) {
	try {
		const pendo = (window as unknown as Window).pendo;
		if (!pendo?.track) {
			return;
		}
		const metadataWithProductName = {
			...metadata,
			product: 'ShareFile - Billing',
			type: event,
		};
		pendo.track(event, metadataWithProductName);
	} catch {}
}
